import http from "./httpService";
// import apiUrl from ".././config.json";
const apiUrl = require("../config.json").apiUrl;

export const getUserPassword = (data) => {
    const apiEndPoint = `${apiUrl}/CM_GetUserIdPwd`;
    return http.post(`${apiEndPoint}`, data);
};

export const updateUserPassword =(data)=>{
    const apiEndPoint = `${apiUrl}/CM_UserReg`;
    return http.post(`${apiEndPoint}`,data); 
  }